export default __webpack_public_path__ + "static/media/SUMMER SALE WEB BANNER.88f2b5dd.png";